module.exports = __webpack_public_path__ + "static/media/05-tutorial.ffac59f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-courses-work/05-tutorial.png
// module id = 374
// module chunks = 0